import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, Select, DatePicker, Switch, InputNumber } from 'antd';
import { IResourceComponentsProps } from '@refinedev/core';
import dayjs from 'dayjs';
import { ConfigVersionSelect } from '@/components/ConfigVersionSelect';

export const OfferEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps } = useForm();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Config Version"
          name="configVersionId"
          extra="Leave empty to apply to every build. Pick a config version to limit this to the app versions mapped to it."
        >
          <ConfigVersionSelect style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Type"
          name="type"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            options={[
              { label: 'Standard', value: 'standard' },
              { label: 'Special', value: 'special' },
              { label: 'Limited Time', value: 'limited_time' },
            ]}
          />
        </Form.Item>
        <Form.Item label="Platform" name="platform">
          <Select
            options={[
              { label: 'All', value: 'all' },
              { label: 'Android', value: 'android' },
              { label: 'iOS', value: 'ios' },
            ]}
          />
        </Form.Item>
        <Form.Item
          label="Start Date"
          name="startDate"
          rules={[
            {
              required: true,
            },
          ]}
          getValueProps={(value) => ({
            value: value ? dayjs(value) : '',
          })}
        >
          <DatePicker showTime />
        </Form.Item>
        <Form.Item
          label="End Date"
          name="endDate"
          rules={[
            {
              required: true,
            },
          ]}
          getValueProps={(value) => ({
            value: value ? dayjs(value) : '',
          })}
        >
          <DatePicker showTime />
        </Form.Item>
        <Form.Item label="Priority" name="priority">
          <InputNumber min={0} />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  );
};
